import Link from 'next/link'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHome } from '@fortawesome/free-solid-svg-icons'

interface BreadcrumbProps {
  categoryName: string
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({ categoryName }) => {
  return (
    <nav className="flex items-center space-x-2 text-gray-500 mb-5">
      {/* Home Icon */}
      <Link href="/" className="flex items-center text-gray-500 hover:text-primary">
        <FontAwesomeIcon icon={faHome} className="mr-1" />
        <span>Trang chủ</span>
      </Link>
      {/* Separator */}
      <span className="text-gray-400">/</span>
      {/* Category Name */}
      <span className="text-gray-700">{categoryName}</span>
    </nav>
  )
}

export default Breadcrumb
